export const LOAD_LESSON_TO_WATCH = 'LOAD_LESSON_TO_WATCH';
export const LOAD_LESSON_TO_WATCH_SUCCESS = 'LOAD_LESSON_TO_WATCH_SUCCESS';
export const LOAD_LESSON_TO_WATCH_FAILED = 'LOAD_LESSON_TO_WATCH_FAILED';
